exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html {\n    /* remove touch delay on iOS */\n    touch-action: manipulation;\n    overflow: hidden;\n\n    width: 100%;\n    height: 100%;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n}\n\n#canvas {\n    display: block;\n    padding: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?-minimize!./src/assets/css/style.css
// module id = 9
// module chunks = 0